export const CONTRACT_STATUSES = {
  paper: "Non dématérialisé",
  unsigned: "Dématérialisé non signé",
  signed: "Signé",
  unknown: "Non renseigné",
};

// Only explicit document states are used; mission dates do not imply signature.
export function getContractStatus(contract) {
  const value = contract.signatureStatus ?? contract.dematerializationStatus;
  const normalized = typeof value === "string" ? value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim() : "";
  const labels = {
    "non dematerialise": "paper",
    "dematerialise non signe": "unsigned",
    "signe": "signed",
  };
  return CONTRACT_STATUSES[labels[normalized]] || CONTRACT_STATUSES.unknown;
}
